var zooplus = {
	appUrlSchema: {
		android: "zooplus-app:/",
		ios: "zooplusApp:/"
	}
};
var bitiba = {
	appUrlSchema: {
		android: "bitiba-app:/",
		ios: "bitibaApp:/"
	}
};
var commonConfig = {
	zooplus: zooplus,
	bitiba: bitiba
};

export { bitiba, commonConfig as default, zooplus };
//# sourceMappingURL=common.json.js.map
